<div class="withSpace">
        <div style="display: grid; grid-template-columns: auto auto; grid: auto / auto auto; justify-content: left;">
            <div class="withSpace">
                <mat-card style="min-height: 500px">
                    <h2>Samples</h2>
                    <div>
                        <mat-slide-toggle [checked]="showDATA" color="primary" (toggleChange)="showDATA=!showDATA; showUI = (!showDATA && !showUI ? true: showUI); filter();">Show DATA components</mat-slide-toggle>
                    </div>
                    <div>
                        <mat-slide-toggle [checked]="showUI" (toggleChange)="showUI=!showUI; showDATA = (!showUI && !showUI ? true: showDATA); filter();">Show UI components</mat-slide-toggle>
                    </div>

                    <mat-nav-list>
                        <mat-list-item *ngFor="let componentType of componentTypes" (click)="changeSelection(componentType)">
                            <mat-icon mat-list-icon [color]="(componentType.allowsData? 'primary' : 'accent')">{{componentType.icon}}</mat-icon>
                            <span matLine [style]="'color: ' + (componentType.allowsData? 'darkblue' : 'deeppink')">{{componentType.name}}</span>
                        </mat-list-item>
                    </mat-nav-list>
                </mat-card>
            </div>
            <div class="withSpace">
                <mat-card style="min-height: 500px">
                    <ng-container *ngIf="selectedComponent">
                        <mat-card-header>
                            <div mat-card-avatar>
<!--                                <mat-icon mat-card-icon>{{selectedComponent.icon}}</mat-icon>-->
                                <mat-icon mat-list-icon [color]="(selectedComponent.allowsData? 'primary' : 'accent')">{{selectedComponent.icon}}</mat-icon>
                            </div>
<!--                            <mat-card-title>{{selectedComponent.name}}</mat-card-title>-->
                            <mat-card-title [style]="'color: ' + (selectedComponent.allowsData? 'darkblue' : 'deeppink')">{{selectedComponent.name}}</mat-card-title>
                            <mat-card-subtitle><p style="width: 200px">{{selectedComponent.description}}</p></mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <div>
                                <div>Sample:
                                    <div style="padding: 10px; border-radius: 5px; border: 1px solid {{(selectedComponent.allowsData ? 'darkblue': 'deeppink')}};">
                                        <ng-container *ngFor="let componentType of allComponentTypes">
                                            <dynamic-renderer *ngIf="componentType.name === selectedComponent.name" [component]="selectedComponent.sample" [formGroup]="formGroup" [data]="null"></dynamic-renderer>
                                        </ng-container>
                                    </div>
                                </div>
                                <div>Allows children:{{selectedComponent.allowsChildren}}</div>
                                <div>Allows data:{{selectedComponent.allowsData}}</div>
                                <span *ngIf="selectedComponent.implementedOptions">Options:</span>
                                <ul>
                                    <li *ngFor="let option of selectedComponent.implementedOptions">
                                        {{option}}
                                    </li>
                                </ul>
                                <span *ngIf="selectedComponent.implementedValidators">Validators:</span>
                                <ul>
                                    <li *ngFor="let validator of selectedComponent.implementedValidators">
                                        {{validator}}
                                    </li>
                                </ul>
                            </div>
                        </mat-card-content>
                    </ng-container>
                    <ng-container *ngIf="selectedComponent === undefined">
                        <p style="text-align: left"> Iterate through the sample list to view supported features of DATA & UI web components. </p>
                        <ol>
                            <li>DATA components that require user input (the user data can be validated using Validators).</li>
                            <li>UI components that require NO user input</li>
                        </ol>
                        <p style="text-align: left"> Validators: </p>
                        <ul>
                            <li *ngFor="let validator of validators">{{validator.key}} = {{validator.label}} validation with message "{{validator.message}}"</li>
                        </ul>

                        <p style="text-align: left"> Both DATA & UI web components have options to manage properties like visibility, layout, color, span, appearance, tooltip. </p>
                        <p style="text-align: left"> Options: </p>
                        <ul>
                            <li *ngFor="let option of options">{{option.key}} = with default value "{{option.value}}" of type "{{option.valueType.name}}"
                                {{ option.predefinedValues ? "with these possible values: '" + option.predefinedValues + "'" : ""}}
                            </li>
                        </ul>
                    </ng-container>
                </mat-card>
            </div>
        </div>
</div>
